import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d6d69f6")

_pushScopeId("data-v-6d6d69f6")
const _hoisted_1 = { class: "card main-orders-list" }
const _hoisted_2 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_3 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_4 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_5 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_7 = { class: "menu-item-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AdvanceSearch = _resolveComponent("AdvanceSearch")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_AdvanceSearch, {
      filter: true,
      filterOption: _ctx.filterOption,
      dateFilter: true,
      filterPlaceholder: 'message.SELECT',
      onSearch: _ctx.searchHandler,
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getQuotations(1, true))),
      onExportFile: _ctx.exportFile
    }, null, 8, ["filterOption", "filterPlaceholder", "onSearch", "onExportFile"]),
    _createVNode(_component_Table, {
      loading: _ctx.loader,
      columns: _ctx.columns,
      rows: _ctx.quotations,
      padding: 5,
      pagination: _ctx.pagination,
      onHandleCurrentChange: _ctx.handleCurrentChange
    }, {
      "cell-quotation_signed_status": _withId(({row:item}) => [
        _createVNode("div", null, [
          (item?.quotation_signed_status == 1)
            ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('message.YES')), 1))
            : (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('message.NO')), 1))
        ])
      ]),
      "cell-is_ordered": _withId(({row:item}) => [
        _createVNode("div", null, [
          (item?.is_ordered == 1)
            ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('message.YES')), 1))
            : (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('message.NO')), 1))
        ])
      ]),
      "cell-total": _withId(({row:item}) => [
        _createVNode("div", null, _toDisplayString(JSON.parse(item?.quotation_totals)?.total?.value), 1)
      ]),
      "cell-actions": _withId(({row:item}) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
        }, [
          _hoisted_6,
          _createVNode("div", {
            class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
          }, [
            _createVNode("div", _hoisted_7, [
              (_ctx.$can('view_quotation_detail'))
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleView(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.VIEW')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["loading", "columns", "rows", "pagination", "onHandleCurrentChange"])
  ]))
})